<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_government_select')
}

const isOnGovernmentSection = computed(() => {
  return route.path.startsWith('/government')
})

const goToGovernment = () => {
  router.push('/government/cabinet')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        Let select your first cabinet member!
      </p>
      <p class="pb-2">
        Take your time to review each ministry and their available candidates. Each candidate offers different bonuses that can significantly impact our empire's development.
      </p>
      <p class="pb-2">
        The candidates require VIP Tokens <GenericIcon type="vip" />, these are acquired automatically over time. In some cases the candidate also requires a weekly salary.
      </p>
      <p class="pb-2">
        Keep in mind that once you appointed someone for a ministry you will not be able to change it later. You can fire them if they no longer serve a purpose.
      </p>
      <p class="pb-2">
        Go ahead and select your first minister when you're ready!
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Choose a ministry and select one of the two available candidates to appoint as your minister.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnGovernmentSection" @click="goToGovernment" class="mr-2">
        Go to Government
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>